import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectComponent } from './select.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FilterOptionsPipe } from './filter-options.pipe';

@NgModule({
    declarations: [SelectComponent, FilterOptionsPipe],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [FilterOptionsPipe],
    exports: [SelectComponent, ReactiveFormsModule],
})
export class SelectModule {}
